import { Alert, Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useReducer, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import PostAddIcon from '@mui/icons-material/PostAdd';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { getFromSession, replaceMultiText } from "../../app/util";
import { settingsReducers } from "./reducers";
import { fetchDataSimple } from "../../services/data.service";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../app/config";
import { time } from "highcharts";
import moment from "moment";
import CircularProgress from '@mui/material/CircularProgress';
import { Chip } from '@mui/material';
import {
    CloseSharp as CloseSharpIcon
}
    from '@mui/icons-material';


const fileTypes = ["xls", "xlsx"];
function FileUploadDragDrop(props) {

    const initalState = {
        data: { files: [], folders: [] },
        ui: {
            request: {
                resType: null,
                status: "idle",
                message: "",
            },
            path: [],
            breadcrumb: []
        },
        parent: null
    };

    const [settingsState, dispatchSettings] = useReducer(settingsReducers, initalState);



    const { app, auth } = useSelector((state) => state);
    const { user, profile } = auth;
    const { app_state } = app.current_state;
    const { ui, data } = settingsState;

    const [file, setFile] = useState(null);
    const [buttonText, setButtonText] = useState("Upload File");

    const handleChange = (file) => {
        setButtonText("Upload File");

        setFile(file);
    };
    const submitFileData = async () => {
        setButtonText("Uploading...");
        let formData = new FormData();
        let uploadReport = props.file_type;
        var file_upload_type;
        if (uploadReport === 'budget_upload') {
            file_upload_type = "BUDGET";
        } else if (uploadReport === 'forecast_upload') {
            file_upload_type = "FORECAST";
        } else if (uploadReport === 'documents_upload') {
            file_upload_type = "DOCUMENT";
        }
        if (file) {
            let newFileName = moment().format('MMM-DD_mm_ss') + "_" + file.name
            //formData.append("file", file);
            formData.append("fileUploadType", file_upload_type);
            if (props.data.parent) {
                formData.append("folderUid", props.data.parent);
            }
            formData.append('file', file, newFileName);
            formData.append("asOfDate", app_state.as_of_date)
            formData.append("documentTags", "")

        }
        const options = {
            method: "POST",
            body: formData,
        };
        const token = getFromSession("token");

        // debugger;
        dispatchSettings({ type: "wait" });
        const correction = {
            "{pid}": app_state.property_id,
        };
        let apiUrl = "upload/property-file/{pid}/";
        apiUrl = replaceMultiText(apiUrl, correction);
        let api = API_BASE_URL + "" + apiUrl;

        let res = await fetch(api, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Authorization": "Token " + token,
                //'Access-Control-Allow-Origin':'*'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: "follow", // manual, *follow, error
            //referrerPolicy: 'origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: formData, // body data type must match "Content-Type" header
        })
        const data = await res.json();
        if (data.status === "success") {
            setFile("");
            props.getListing("navigateFolder")
            dispatchSettings({ type: "onFileUpload" });
        } else {
            dispatchSettings({ type: "onResponseError" });
        }
        setTimeout(() => {
            dispatchSettings({ type: "onHideAlert" });
        }, 3000);

    }

    const deselectFile = () => {
        setFile("");
    }

    let fileName = (file && file.name) ? file.name : "";
    let disbaled = (file && file.name) ? true : false;
    return (
        <>
            {/* {
            ui.request.message !== "" ? (
                <Box>
                    <Alert icon={false} severity="success" sx={{ minWidth: "500px !important", pl: "39%" }}>
                        {ui.request.message}
                    </Alert>
                </Box>
            ) : (
                <></>
            )
            } */}

            <FileUploader
                handleChange={handleChange}
                name="file"
                label="Select or Drop a file to upload"
                classes="drop_area"
                disabled={disbaled}
                children={<UploadInnerHtml buttonText={buttonText} fileName={fileName} deselectFile={deselectFile} submitFileData={submitFileData} />}
            />

        </>
    );
}



export function UploadInnerHtml(props) {
    let isDisabled = (props.buttonText !== "Upload File") ? "disabled" : "";
    return (
        <>
            {(props.fileName) ?

                <>
                    <div className="file-container">
                        <div className="upload-area-filename">
                            <Chip className="file-name" label={props.fileName} onDelete={props.deselectFile} />
                        </div>
                        <div className="upload-area-button">
                            <Button variant="contained"
                                className="upload-btn"
                                disabled={isDisabled}
                                startIcon={(props.buttonText === "Upload File") ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14" fill="none">
                                        <path d="M13.5626 6.99998C13.5653 8.04187 13.2273 9.05609 12.6001 9.88802C12.5655 9.93399 12.5223 9.9727 12.4728 10.0019C12.4233 10.0312 12.3685 10.0504 12.3116 10.0585C12.2546 10.0665 12.1967 10.0633 12.141 10.049C12.0853 10.0347 12.033 10.0095 11.987 9.97498C11.9411 9.94043 11.9024 9.89718 11.8731 9.84767C11.8439 9.79817 11.8247 9.74339 11.8166 9.68646C11.8085 9.62954 11.8117 9.57158 11.8261 9.51589C11.8404 9.46021 11.8655 9.40789 11.9001 9.36193C12.4135 8.68175 12.6901 7.85217 12.6876 6.99998C12.6876 5.95569 12.2727 4.95417 11.5343 4.21574C10.7959 3.47732 9.79436 3.06248 8.75007 3.06248C7.70578 3.06248 6.70426 3.47732 5.96584 4.21574C5.22741 4.95417 4.81257 5.95569 4.81257 6.99998C4.81257 7.11601 4.76648 7.22729 4.68443 7.30934C4.60238 7.39138 4.4911 7.43748 4.37507 7.43748C4.25904 7.43748 4.14776 7.39138 4.06571 7.30934C3.98367 7.22729 3.93757 7.11601 3.93757 6.99998C3.93736 6.55847 3.9979 6.11904 4.11749 5.69404C4.05788 5.68748 3.99773 5.68748 3.93757 5.68748C3.24138 5.68748 2.5737 5.96404 2.08142 6.45632C1.58913 6.94861 1.31257 7.61628 1.31257 8.31248C1.31257 9.00867 1.58913 9.67635 2.08142 10.1686C2.5737 10.6609 3.24138 10.9375 3.93757 10.9375H5.25007C5.3661 10.9375 5.47738 10.9836 5.55943 11.0656C5.64148 11.1477 5.68757 11.2589 5.68757 11.375C5.68757 11.491 5.64148 11.6023 5.55943 11.6843C5.47738 11.7664 5.3661 11.8125 5.25007 11.8125H3.93757C3.45642 11.8126 2.98041 11.7135 2.53927 11.5214C2.09814 11.3293 1.70135 11.0482 1.3737 10.6959C1.04604 10.3435 0.794558 9.92742 0.634948 9.47351C0.475339 9.0196 0.411033 8.53765 0.446048 8.05777C0.481063 7.5779 0.614645 7.11039 0.838454 6.68446C1.06226 6.25852 1.37149 5.88331 1.74682 5.58225C2.12215 5.2812 2.55552 5.06076 3.01987 4.93471C3.48422 4.80866 3.96958 4.77971 4.44562 4.84967C4.93037 3.88014 5.72823 3.10266 6.70997 2.64315C7.69171 2.18364 8.79982 2.06902 9.85483 2.31786C10.9098 2.56669 11.8499 3.1644 12.5229 4.01418C13.1958 4.86395 13.5622 5.91602 13.5626 6.99998ZM8.6221 6.69045C8.58147 6.64977 8.53322 6.6175 8.48011 6.59548C8.427 6.57347 8.37007 6.56213 8.31257 6.56213C8.25508 6.56213 8.19815 6.57347 8.14504 6.59548C8.09192 6.6175 8.04367 6.64977 8.00304 6.69045L6.25304 8.44045C6.21239 8.48109 6.18015 8.52935 6.15815 8.58246C6.13615 8.63557 6.12483 8.69249 6.12483 8.74998C6.12483 8.80746 6.13615 8.86439 6.15815 8.91749C6.18015 8.9706 6.21239 9.01886 6.25304 9.05951C6.33513 9.1416 6.44648 9.18772 6.56257 9.18772C6.62006 9.18772 6.67698 9.1764 6.73009 9.1544C6.7832 9.1324 6.83146 9.10016 6.8721 9.05951L7.87507 8.05599V11.375C7.87507 11.491 7.92117 11.6023 8.00321 11.6843C8.08526 11.7664 8.19654 11.8125 8.31257 11.8125C8.4286 11.8125 8.53988 11.7664 8.62193 11.6843C8.70398 11.6023 8.75007 11.491 8.75007 11.375V8.05599L9.75304 9.05951C9.79369 9.10016 9.84195 9.1324 9.89506 9.1544C9.94816 9.1764 10.0051 9.18772 10.0626 9.18772C10.1201 9.18772 10.177 9.1764 10.2301 9.1544C10.2832 9.1324 10.3315 9.10016 10.3721 9.05951C10.4128 9.01886 10.445 8.9706 10.467 8.91749C10.489 8.86439 10.5003 8.80746 10.5003 8.74998C10.5003 8.69249 10.489 8.63557 10.467 8.58246C10.445 8.52935 10.4128 8.48109 10.3721 8.44045L8.6221 6.69045Z" fill="#00415F" />
                                    </svg>
                                    : <CircularProgress size={15} sx={{ color: "#00415F" }} />}
                                onClick={(e) => { e.stopPropagation(); props.submitFileData() }}
                                size="midium">{props.buttonText}</Button>
                        </div>
                    </div>
                </>
                :
                <div className="upload-area">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path d="M17.1922 6.43281L12.8172 2.05781C12.7591 1.99979 12.6902 1.95378 12.6143 1.92241C12.5384 1.89105 12.4571 1.87494 12.375 1.875H4.875C4.54348 1.875 4.22554 2.0067 3.99112 2.24112C3.7567 2.47554 3.625 2.79348 3.625 3.125V16.875C3.625 17.2065 3.7567 17.5245 3.99112 17.7589C4.22554 17.9933 4.54348 18.125 4.875 18.125H16.125C16.4565 18.125 16.7745 17.9933 17.0089 17.7589C17.2433 17.5245 17.375 17.2065 17.375 16.875V6.875C17.3751 6.7929 17.359 6.71159 17.3276 6.63572C17.2962 6.55985 17.2502 6.4909 17.1922 6.43281ZM13 4.00859L15.2414 6.25H13V4.00859ZM16.125 16.875H4.875V3.125H11.75V6.875C11.75 7.04076 11.8158 7.19973 11.9331 7.31694C12.0503 7.43415 12.2092 7.5 12.375 7.5H16.125V16.875ZM13 11.875C13 12.0408 12.9342 12.1997 12.8169 12.3169C12.6997 12.4342 12.5408 12.5 12.375 12.5H11.125V13.75C11.125 13.9158 11.0592 14.0747 10.9419 14.1919C10.8247 14.3092 10.6658 14.375 10.5 14.375C10.3342 14.375 10.1753 14.3092 10.0581 14.1919C9.94085 14.0747 9.875 13.9158 9.875 13.75V12.5H8.625C8.45924 12.5 8.30027 12.4342 8.18306 12.3169C8.06585 12.1997 8 12.0408 8 11.875C8 11.7092 8.06585 11.5503 8.18306 11.4331C8.30027 11.3158 8.45924 11.25 8.625 11.25H9.875V10C9.875 9.83424 9.94085 9.67527 10.0581 9.55806C10.1753 9.44085 10.3342 9.375 10.5 9.375C10.6658 9.375 10.8247 9.44085 10.9419 9.55806C11.0592 9.67527 11.125 9.83424 11.125 10V11.25H12.375C12.5408 11.25 12.6997 11.3158 12.8169 11.4331C12.9342 11.5503 13 11.7092 13 11.875Z" fill="#606060" />
                    </svg>
                    <div className="upload-area-txt">Select or Drop a file to upload</div>
                </div>
            }
        </>
    )
}




export default FileUploadDragDrop;